import React, { Component } from 'react';
import BottomNav from './BottomNav'
import {Link} from "react-router-dom";
import Slider from "react-slick";
import Axios from 'axios';
import jwt_decode from 'jwt-decode';
import { CSVLink } from "react-csv";
import MySchedule from './MySchedule'

const csvGoldenTicketHeaders = [
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Company", key: "company" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Title", key: "title" },
    { label: "Credentials", key: "credentials" },
    { label: "Address1", key: "address1" },
    { label: "Address2", key: "address2" },
    { label: "Zip", key: "zip" },
    { label: "Phone", key: "phone" },
    { label: "Email", key: "email" },
    { label: "Earned Points", key: "total_points" },
  ];

class Lobby extends Component {
    constructor(){
        super();
        this.state={
            messageModal:false,
            sponsersImgList:[],
            mediaPartnerList:[],
            producedByList:[],
            sectionLoader:true,
            userMessages:[],
            leaderBoardParagraph:[],
            goldenTicketPointEarners:[],
            csvHeaders:csvGoldenTicketHeaders,
            certificateModal:false,
            iframeLoader:true,
            myScheduleModal:false,
            leftSponsers:0
        }
    }
    myScheduleModalHandler = (e) => {
        e.preventDefault();
        this.setState({myScheduleModal:!this.state.myScheduleModal})
    }
    messageModalHandler = (e) =>{
        e.preventDefault();
        this.setState({messageModal:!this.state.messageModal})
    }
    certificateModalHandler = (e) => {
        e.preventDefault();
        this.setState({certificateModal:!this.state.certificateModal,iframeLoader:true})
    }
    goldenTicketModalHandler = (e) => {
        e.preventDefault();
        this.setState({pageLoader:true});
        Axios.get(`${global.config.requestUrl}user/getGoldenTicketUsers?eventId=${localStorage.getItem('eventId')}`,
        {headers: { "auth-token": localStorage.exhibitorToken }}
        )
        
        .then(res => {
            if(!res.data.errorCode){
                this.setState({goldenTicketPointEarners:res.data.data});
            }
            this.setState({pageLoader:false});
        })
        .catch(err => {
            console.log(err);
        });
        this.setState({goldenTicketModal:!this.state.goldenTicketModal})
    }
    hideIframeLoader = () => {
        this.setState({iframeLoader:false});
    }
    componentDidMount(){


        // -1,-6,1441  => -10
        // -1          => -1
        // -6          => -6
        // 1441        => -10
        // -1,1441     => -10
        // -6,1441     => -10
        // -1,-6     => -1 
            
                if(localStorage.getItem('roles')){
                    var rolesArr = localStorage.getItem('roles').split(",");
                    var currentRole = -10;
        
                    if(rolesArr.length > 2 ){
                        currentRole = -10;
                    }
                    if((rolesArr.indexOf('-1') !== -1 || rolesArr.indexOf('-7') !== -1) && rolesArr.indexOf('-6') !== -1 && rolesArr.length < 3 ){
                        currentRole = -1;
                    }
                    if(rolesArr.indexOf('-1') == -1 && rolesArr.indexOf('-7') == -1 && rolesArr.indexOf('-6') !== -1 && rolesArr.length == 1 ){
                        currentRole = -6;
                    }
                    if((rolesArr.indexOf('-1') !== -1 || rolesArr.indexOf('-7') !== -1) && rolesArr.indexOf('-6') == -1 && rolesArr.length == 1 ){
                        currentRole = -1;
                    }
                    if((rolesArr.indexOf('-1') !== -1 && rolesArr.indexOf('-7') !== -1) && rolesArr.length === 2  ){
                        currentRole = -1;
                    }
                    localStorage.setItem('currentRole',currentRole);
                    
                }
        
                const token = localStorage.exhibitorToken;
                const decoded = jwt_decode(token);
                const details = {
                    username: decoded.email,
                    eventId:localStorage.getItem('eventId'),
                    role:currentRole.toString()
                }
        
                Axios.post(`${global.config.requestUrl}user/getUserDetails`, details,
                        {headers: { "auth-token": localStorage.exhibitorToken }}
                    )
                    .then(res => {
                         if(res.data.errorCode === 0){
                            localStorage.setItem('companyContactUrl',res.data.data[0].profilePic)
                            localStorage.setItem('userProfilePic','')
                            localStorage.setItem('useraccname',res.data.data[0].name)
                            if(res.data.data[0].exhibitorId){
                                localStorage.setItem('userId',res.data.data[0].exhibitorId)
                            }
                            if(res.data.data[0].speakerId){
                                localStorage.setItem('userId',res.data.data[0].speakerId)
                            }
                            if(res.data.data[0].userId){
                                localStorage.setItem('userId',res.data.data[0].userId)
                                localStorage.setItem('userProfilePic',res.data.data[0].profilePic)
                            }
                            localStorage.setItem('company',res.data.data[0].company)
                            if(res.data.data[0].profilePic !==""){
                                document.getElementById("profile_img").src = res.data.data[0].profilePic;
                            }else{
                                document.getElementById("profile_img").src = '/images/placeholder-profile.jpg';;  
                            }
                        }
                        this.setState({pageLoader:false});
                        
                    })
                    .catch(err => {
                        console.log(err);
                    });
                  
                Axios.get(`${global.config.requestUrl}user/getSponsorsLogos?eventId=${localStorage.getItem('eventId')}&type=3`,
                {headers: { "auth-token": localStorage.exhibitorToken }}
                )
                
                .then(res => {
                    
        
                    if(res.data.errorCode === 0){
                        var leftSponsers = res.data.data.length / 2;
                        this.setState({sponsersImgList:res.data.data, mediaPartnerList:res.data.mediaPartner, producedByList:res.data.producedBy,sectionLoader:false,leftSponsers:leftSponsers}) 
                        
                    } else{
                        this.setState({sponsersImgList:[
                            {'logo':process.env.PUBLIC_URL + '/images/sponser-dummy.png','exhibitor_id':null},
                            {'logo':process.env.PUBLIC_URL + '/images/sponser-dummy.png','exhibitor_id':null},
                            {'logo':process.env.PUBLIC_URL + '/images/sponser-dummy.png','exhibitor_id':null},
                            {'logo':process.env.PUBLIC_URL + '/images/sponser-dummy.png','exhibitor_id':null},
                            {'logo':process.env.PUBLIC_URL + '/images/sponser-dummy.png','exhibitor_id':null},
                            {'logo':process.env.PUBLIC_URL + '/images/sponser-dummy.png','exhibitor_id':null},
                            
                        ]});
                        this.setState({sectionLoader:false,leftSponsers:3})
                    }
        
                   
                   
                })
                .catch(err => {
                    console.log(err);
                });
                    
                Axios.get(`${global.config.requestUrl}user/getEventMessages?eventId=${localStorage.getItem('eventId')}`,
                {headers: { "auth-token": localStorage.exhibitorToken }}
                )
                
                .then(res => {
                    if(res.data.errorCode === 0){
                        this.setState({userMessages:res.data.data}) 
                    }
                     
                })
                .catch(err => {
                    console.log(err);
                });
        
                Axios.get(`${global.config.requestUrl}user/getLeaderboardContent?eventId=${localStorage.getItem('eventId')}`,
                {headers: { "auth-token": localStorage.exhibitorToken }}
                )
                
                .then(res => {
        
                    if(res.data.errorCode === 0){
                        this.setState({leaderBoardParagraph:res.data.data})
                    }
                               
                    
                })
                .catch(err => {
                    console.log(err);
                });
        
                }
    render() {
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            fade: true,
            arrows:false,
          };
        return (
            <React.Fragment>
                <section className="bg9 signleScreen attendeeLobbyPage">
                    <div className="centerSponsers">
                        <ul>
                            <li><img src={process.env.PUBLIC_URL + '/images/csda/mid-banner.jpg'} alt="" /></li>
                        </ul>
                    </div>
                    <div className="twoSideSponsers">
                        <div className="topLeftSponsers">
                            <ul>
                                {
                                    this.state.sectionLoader
                                    ?
                                    (
                                        <div className="sectionLoader">
                                            <img src={process.env.PUBLIC_URL + '/images/loader.gif'} alt="" />
                                        </div>
                                    )
                                    :
                                    null
                                }
                                { 
                                    this.state.sponsersImgList.slice(this.state.leftSponsers,this.state.sponsersImgList.length).map((sponsers,index )=> (
                                        <li key={index}>
                                        {
                                            sponsers.exhibitor_id === 0
                                            ?
                                            (
                                            <a href={sponsers.sponsor_link} target="_blank">
                                                <img src={sponsers.logo} alt=""/>
                                            </a>
                                            )
                                            :
                                            <Link to={`/csda/attendee/exhibitorBooth/${sponsers.exhibitor_id}`}>
                                                <img src={sponsers.logo} alt=""/>
                                            </Link>
                                        }
                                            
                                        </li>
                                    ))
                                    
                                }                            
                            </ul>
                        </div>
                        <div className="topRightSponsers">
                            
                            <ul>
                                {
                                    this.state.sectionLoader
                                    ?
                                    (
                                        <div className="sectionLoader">
                                            <img src={process.env.PUBLIC_URL + '/images/loader.gif'} alt="" />
                                        </div>
                                    )
                                    :
                                    null
                                }
                                { 
                                    this.state.sponsersImgList.slice(0,this.state.leftSponsers).map((sponsers,index) => (
                                        <li key={index}>
                                        {
                                            sponsers.exhibitor_id === 0
                                            ?
                                            (
                                            <a href={sponsers.sponsor_link} target="_blank">
                                                <img src={sponsers.logo} alt=""/>
                                            </a>
                                            )
                                            :
                                            <Link to={`/csda/attendee/exhibitorBooth/${sponsers.exhibitor_id}`}>
                                                <img src={sponsers.logo} alt=""/>
                                            </Link>
                                        }
                                        </li>
                                    ))
                                    
                                }                            
                            </ul>
                            
                        </div>
                    </div>
                    
                    <div className="resPonsiveBar">
                        {/* <div className="lobbyLinks"  onClick={this.goldenTicketModalHandler} >
                            <img src={process.env.PUBLIC_URL + '/images/csda/lobby-links-stand.png'} alt="" />
                            <img src={process.env.PUBLIC_URL + '/images/link-people.png'} alt="" className="people" />
                        </div> */}
                        <div className="lobbyMsg"  onClick={this.messageModalHandler}>
                            <img src={process.env.PUBLIC_URL + '/images/csda/lobby-msg-stand.png'} alt="" />
                            <img src={process.env.PUBLIC_URL + '/images/msg-people.png'} alt="" className="people" />
                            <div className="msgScroller">
                                {/* <h3>Message Board</h3> */}
                                <Slider {...settings}>
                                    { 
                                        this.state.userMessages.map(message => (
                                            <div className="msg" key={message.msg_id}>
                                                <h4>{message.title}</h4>
                                                <p>{message.description}</p>
                                            </div>
                                        ))
                                        
                                    } 
                                </Slider>
                                <div className="text-left">
                                    <button>View More <i className="fa fa-long-arrow-right"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        window.innerWidth < 767
                        ?
                        <div className="lobbyMobileNav">
                            <ul>
                                <li>
                                    <Link to="/csda/attendee/lobby">
                                        <img src={process.env.PUBLIC_URL + '/images/csda/bottom-nav-lobby.png'} alt="" />
                                        <span>Lobby</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/csda/attendee/exhibitHall">
                                        <img src={process.env.PUBLIC_URL + '/images/csda/bottom-nav-exhibit-hall.png'} alt="" />
                                        <span>Exhibit Hall</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/csda/attendee/conferenceCenter">
                                        <img src={process.env.PUBLIC_URL + '/images/csda/bottom-nav-conference-hall.png'} alt="" />
                                        <span>Conference Center</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/csda/attendee/networkingLounge">
                                        <img src={process.env.PUBLIC_URL + '/images/csda/bottom-nav-networking-lounge.png'} alt="" />
                                        <span>Networking lounge</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={this.myScheduleModalHandler}>
                                        <img src={process.env.PUBLIC_URL + '/images/csda/bottom-nav-schedule_button.png'} alt="" />
                                        <span>My Schedule</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/csda/attendee/poster">
                                        <img src={process.env.PUBLIC_URL + '/images/csda/bottom-nav-poster.png'} alt="" />
                                        <span>Posters</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        :
                        null
                    }
                    <div className="stickyBtn">
                        <button onClick={this.certificateModalHandler}><i className="fa fa-address-card"></i> <span>Conference Survey</span></button>
                        <a href={process.env.PUBLIC_URL + '/pdf/CSDA-CE-Certificate.pdf'} target="_blank"><i className="fa fa-address-card"></i> <span>CSDA CE Verification Form</span></a>
                    </div>
                    <BottomNav />
                </section>
                {/*=====Message Board Modal=====*/}
                {
                    this.state.messageModal 
                    ?
                    <div className="modalPopUp">
                        <div className="modalPopUpInr p-0">
                            <div className="modalPopUpClose" onClick={this.messageModalHandler}><i className="fa fa-times"></i></div>
                            <h3 className="modalHeading">Messages</h3>
                            <div className="modalContent p-4">
                                <div className="msgListWrp">
                                    <ul>
                                    { 
                                        this.state.userMessages.map(message => (
                                            <li className="msg" key={message.msg_id}>
                                                <h4>{message.title}</h4>
                                                <p>{message.description}</p>
                                            </li>
                                        ))
                                        
                                    } 
                                    </ul>
                                </div>                                
                            </div>
                        </div>
                    </div> 
                    :
                    null
                }
                {/*=====Certificate Modal=====*/}
                {
                    this.state.certificateModal
                    ?
                    <div className="midModal verticleCenterModal">
                        <div className="midContentWrp">
                            <div className="modalPopUpClose" onClick={this.certificateModalHandler}><i className="fa fa-times"></i></div>
                            <h3>Conference Survey</h3>
                            <div className="midContentBx">
                              {
                               this.state.iframeLoader
                               ?
                               (
                                <div className="loaderWrp">
                                    <div className="loaderInr">
                                        <img src={process.env.PUBLIC_URL + '/images/loader.gif'} alt="" />
                                    </div>
                                </div>
                               )
                               :
                               null
                              }
                              
                                <iframe width="100%" height="450" src={`https://www.tslwebreg.com/eventSurvey.php?user_id=${localStorage.getItem('accountId')}&event_id=${localStorage.getItem('eventId')}&reg_id=${localStorage.getItem('userId')}&role=${localStorage.getItem('currentRole')}`} frameBorder="0" allow="accelerometer;  encrypted-media; gyroscope; picture-in-picture" allowFullScreen autoPlay="false" onLoad={this.hideIframeLoader}></iframe> 
                            </div>                               
                        </div>
                    </div>
                    :
                    null
                }
                {/*=====My Schedule Modal=====*/}
                {
                    this.state.myScheduleModal
                    ?
                    <div className="midModal">
                        <div className="midContentWrp">
                            <div className="modalPopUpClose" id="myschedulepopup" onClick={this.myScheduleModalHandler}><i className="fa fa-times"></i></div>
                            <MySchedule props={this.props} />                             
                        </div>
                    </div>
                    :
                    null
                }
                {/*=====Golden Ticket Modal=====*/}
                {
                    this.state.goldenTicketModal
                    ?
                    <div className="midModal">
                        <div className="midContentWrp">
                            <div className="modalPopUpClose" onClick={this.goldenTicketModalHandler}><i className="fa fa-times"></i></div>
                            <h3>Leaderboard</h3>
                                <div className="midContentBx">
                                { 
                                    this.state.leaderBoardParagraph.map(paragraph => (
                                        <div className="mb-2" key={paragraph.golden_ticket_id}>
                                            <p>{paragraph.header.replace(/(<([^>]+)>)/gi, "")}</p>
                                        </div>
                                    ))    
                                }
                                {/* <div className="text-right mb-3">
                                    <CSVLink data={this.state.goldenTicketPointEarners} headers={this.state.csvHeaders} filename="goldenticketearners.csv" className="btn btn-primary">
                                        <span>Export List</span>
                                        <i className="fa fa-download ml-2"></i>
                                    </CSVLink>
                                </div> */}
                                <div className="leaderTable">
                                    {
                                     this.state.pageLoader
                                     ?
                                     (
                                     <div className="loaderWrp">
                                        <div className="loaderInr">
                                          <img src={process.env.PUBLIC_URL + '/images/loader.gif'} alt="" />
                                        </div>
                                     </div>
                                     )
                                     :
                                     null
                                    }
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Points</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            { 
                                              this.state.goldenTicketPointEarners.map(earner => (
                                                <tr key={earner.name}>
                                                  <td>{earner.name}</td>
                                                  <td>{earner.total_points}</td>
                                                </tr>
                                              ))    
                                            }
                                            { 
                                              this.state.goldenTicketPointEarners.length == 0
                                              ?
                                              <tr><td colSpan="2">No Data Found</td></tr>
                                              :
                                              null 
                                            }
                                          </tbody>
                                        </table>
                                    </div>
                                </div>                               
                        </div>
                    </div>
                    :
                    null
                }
            </React.Fragment>
        )
    }
}
export default Lobby; 
